var map = {
	"./about-us/about-us.vue": [
		"e235",
		"vendors",
		"chunk-0809518a"
	],
	"./advanced-trading/advanced-trading.vue": [
		"56bf",
		"chunk-374ef117"
	],
	"./app-restricted.vue": [
		"0f13",
		"chunk-2b87003e"
	],
	"./buy-sell/buy-sell.vue": [
		"1bd9",
		"vendors",
		"chunk-71bbd766",
		"chunk-abec2b26"
	],
	"./external-page.vue": [
		"c134",
		"chunk-4469333b"
	],
	"./home/index.vue": [
		"7abe"
	],
	"./home/overview.vue": [
		"5cae",
		"vendors",
		"chunk-25db9150"
	],
	"./home/trade-order-details.vue": [
		"263e",
		"chunk-32e09449"
	],
	"./home/trading-history.vue": [
		"cf2b",
		"chunk-5fe8a24d"
	],
	"./home/trading.vue": [
		"6360",
		"chunk-49e5e744"
	],
	"./kyc.vue": [
		"20a7",
		"vendors",
		"chunk-42e52328",
		"chunk-70c99922",
		"chunk-a915e2e8",
		"chunk-39b2812a"
	],
	"./login.vue": [
		"dd7b",
		"vendors",
		"chunk-858cd9f8",
		"chunk-670063b3",
		"chunk-774df15e"
	],
	"./nft/details.vue": [
		"1273",
		"chunk-3abd00a0"
	],
	"./nft/sendout/sendout.vue": [
		"8050",
		"chunk-0f3d54a6",
		"chunk-381c1208"
	],
	"./page-aml-questionnaire.vue": [
		"99c1",
		"vendors",
		"chunk-42e52328",
		"chunk-1b7bb9a8"
	],
	"./page-not-found.vue": [
		"3803",
		"chunk-0447647e"
	],
	"./partner/partner-list.vue": [
		"66ff",
		"chunk-02f9af16",
		"chunk-7898922a"
	],
	"./partner/partner-token-info.vue": [
		"e15a",
		"chunk-3d0e99f4"
	],
	"./partner/partner-trading.vue": [
		"c66b",
		"vendors",
		"chunk-92c18a06"
	],
	"./partner/partner.vue": [
		"d4fc",
		"vendors",
		"chunk-8a7cfc2c",
		"chunk-49c45998",
		"chunk-3d0e99f4",
		"chunk-bb8b491c"
	],
	"./partner/polls-carousel.vue": [
		"c163",
		"vendors",
		"chunk-3be60ef1"
	],
	"./partner/polls-list.vue": [
		"1a8c7",
		"chunk-5133b773",
		"chunk-98a7ed9c"
	],
	"./partner/product-carousel.vue": [
		"77ba",
		"vendors",
		"chunk-49c45998",
		"chunk-6a89ebe7"
	],
	"./poll/poll.vue": [
		"6223",
		"vendors",
		"chunk-5832cd5a"
	],
	"./polls/polls.vue": [
		"4df6",
		"chunk-5133b773",
		"chunk-93666aa2"
	],
	"./profile/edit-username.vue": [
		"92ad",
		"chunk-ae5802c0"
	],
	"./profile/profile-details.vue": [
		"0801",
		"vendors",
		"chunk-3c00c32b"
	],
	"./requirement/requirement.vue": [
		"e3d9",
		"chunk-d7d832c0",
		"chunk-13d6ed89",
		"chunk-caaa2b2a"
	],
	"./settings/settings.vue": [
		"b986",
		"chunk-34496c61"
	],
	"./support/support.vue": [
		"c0fc",
		"chunk-e1c5d156"
	],
	"./token-hunt.vue": [
		"af40",
		"chunk-c4104292"
	],
	"./wallet/receive.vue": [
		"30fb",
		"chunk-26298e53"
	],
	"./wallet/topup/international/topup.vue": [
		"91bb",
		"vendors",
		"chunk-71bbd766",
		"chunk-78c4dda8"
	],
	"./wallet/topup/topup-base.vue": [
		"2c54",
		"chunk-097bb232"
	],
	"./wallet/topup/usa/topup.vue": [
		"997a",
		"vendors",
		"chunk-71bbd766",
		"chunk-2902549d"
	],
	"./wallet/transactions-filters.vue": [
		"ade6",
		"vendors",
		"chunk-e0f7657a"
	],
	"./wallet/transactions.vue": [
		"b6df",
		"vendors",
		"chunk-e0f7657a",
		"chunk-2171e824"
	],
	"./wallet/withdraw.vue": [
		"6b47",
		"vendors",
		"chunk-71bbd766",
		"chunk-16e8fd3f",
		"chunk-365bf4bc"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;